import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrCurrentFQuarter = createSelector(
  [selectQbrState],
  ({ documentSettings }) => documentSettings.currentFQuarter
)
